import { configureStore } from '@reduxjs/toolkit';

import { alertReducer } from './alert.slice';
import { authReducer } from './auth.slice';
import { usersReducer } from './users.slice';
import { vehiclesReducer } from './vehicles.slice';
import { sidePanelReducer } from './sidePanel.slice';
import { filtersReducer } from './filters.slice';
import { preAlertReducer } from './preAlert.slice';
import { mapReducer } from './map.slice';
import { eventsReducer } from './events.slice';
import { emailsReducer } from './emails.slice';
import { contextReducer } from './contextDetails.slice';
import { dataCollectorReducer } from './dataCollector.slice';
import { diagnosticLoggerReducer } from './diagnosticLogger.slice';

export * from './alert.slice';
export * from './auth.slice';
export * from './users.slice';
export * from './vehicles.slice';
export * from './filters.slice';
export * from './preAlert.slice';
export * from './map.slice';
export * from './events.slice';
export * from './emails.slice';
export * from './contextDetails.slice';
export * from './dataCollector.slice';
export * from './diagnosticLogger.slice';


export const store = configureStore({
    reducer: {
        alert: alertReducer,
        auth: authReducer,
        users: usersReducer,
        vehicles: vehiclesReducer,
        sidePanel: sidePanelReducer,
        filters: filtersReducer,
        preAlerts: preAlertReducer,
        map: mapReducer,       
        events: eventsReducer, 
        emails: emailsReducer,
        contextDetails: contextReducer,
        dataCollector: dataCollectorReducer,
        diagnosticLogger: diagnosticLoggerReducer,
    },
});